let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jUx2Z")).then(() => parcelRequire('4raZH'));